/**
 * The only place the app leaves Next's router and performs a full document
 * navigation. Isolated so the intent is explicit at call sites and so the
 * behaviour can be asserted in tests, where `window.location` is not writable.
 */
export const hardNavigate = (url: string) => {
	window.location.assign(url);
};

export const hardReplace = (url: string) => {
	window.location.replace(url);
};

export const getOrigin = () =>
	typeof window !== 'undefined' ? window.location.origin : '';

/** Turns an app-relative path into an absolute URL on the current origin. */
export const toAbsoluteUrl = (path: string) => `${getOrigin()}${path}`;
